module.exports = __webpack_public_path__ + "img/car_04.e846ef17.jpg";